import { BlogConstants, BlogDetailsProps, BlogPostsRequestByFilter } from 'models/blog-types';
import { getIdsFromArray, useDictionary } from 'lib/utils';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import BlogPostsGrid from './BlogPostsGrid';
import classNames from 'classnames/bind';
import styles from './Blog.module.scss';

// See same implementation in PodcastListing.tsx
const RelatedBlogPosts = (props: BlogDetailsProps): React.JSX.Element => {
  const relatedPostsLabel = useDictionary('Related Posts');

  const cx = classNames.bind(styles);
  const cardColumns = +BlogConstants.DefaultRelatedColumns; // Show 2 columns - if editor choose to show more than 2 related posts, each row will contain two posts
  const { className, fields } = props;
  const { blogTopics, blogAudience, numberOfRelatedPosts } = fields;
  const relatedBlogHeadingLevelValue = 'h2';
  const maxPostsToShow = +(numberOfRelatedPosts?.value || 0);

  const blogPostsRequest: BlogPostsRequestByFilter = {
    blogAudience: getIdsFromArray(blogAudience),
    blogTopics: getIdsFromArray(blogTopics),
    postsToShow: maxPostsToShow,
    showFeaturedPostsOnly: false,
  };

  return (
    <BlogPostsGrid
      titleHeadingLevelValue={relatedBlogHeadingLevelValue}
      className={cx('related-blog-posts', className)}
      title={{ value: relatedPostsLabel }}
      blogPostsRequest={blogPostsRequest}
      cardColumns={cardColumns}
      excludeContextItem={true}
    />
  );
};

export default compose<BlogDetailsProps>(withStyles())(RelatedBlogPosts);
